import { Box, Stack } from "@chakra-ui/layout";
import { Button } from "components";
import { Heading} from "@chakra-ui/react";
import { IProduct } from "interfaces/product.interface";
import { InternalLink } from "components/atoms/InternalLink";
import { EXTERNAL_LINKS } from "config/routes";

export const PricingCard = ({ product }: { product: IProduct }) => {
  const { name, description, price, additionalCharges, color } = product;
  return (
    <Box
      bg="white"
      rounded="md"
      height={'100%'}
      textAlign="center"
      overflow="hidden"
      shadow="xs"
      p={10}
    >
      <Heading fontSize="lg" mb={4} fontWeight={600} color={`${color}.500`}>
        {name}
      </Heading>

      <Box
        fontSize="4xl"
        mb={3}
        display="inline-flex"
        alignItems="center"
        lineHeight="none"
      >
        <Box lineHeight="none" fontWeight={600}>
          {price}
        </Box>
        <Box
          fontSize="md"
          mt="auto"
          lineHeight="none"
          pb="4px"
          pl={1}
          color="gray.500"
        >
        </Box>
      </Box>
      <Box color="gray.500" mb={5}>
        {additionalCharges}
      </Box>
      <Stack>
        <InternalLink href={EXTERNAL_LINKS.SIGNUP_UP.href}>
          <Button isBlock size="lg">
            Get started
          </Button>
        </InternalLink>
      </Stack>
    </Box>
  );
};
